import { Collapse } from '@chakra-ui/react';
import { Body, Box, Divider, Stack } from '@hover/blueprint';
import React, { FC } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { ILinkGroup } from '../../../interfaces/ILinksGroup';

export interface Props extends ILinkGroup {
  isOpen?: boolean;
  onToggle?: () => void;
}

const FooterMobileItems: FC<Props> = ({ label, links, onToggle, isOpen }) => (
  <Stack>
    <Box display="flex" py={200} justify="space-between" align="start">
      <Body
        isBold
        color="neutral.0"
        textTransform="uppercase"
        size={500}
        w="100%"
        onClick={() => {
          if (onToggle) onToggle();
        }}
      >
        {label}
      </Body>
    </Box>

    <Collapse in={isOpen}>
      <Stack borderStyle="solid" borderColor="black" align="start">
        {links?.map(child => (
          <Body
            py={200}
            key={child.label}
            as={GatsbyLink}
            to={child.to}
            color="brandNavy.200"
            textTransform="capitalize"
            size={500}
          >
            {child.label}
          </Body>
        ))}
      </Stack>
    </Collapse>
    <Divider
      borderWidth="1px"
      borderTopWidth={0}
      borderColor="brandNavy.300"
      orientation="horizontal"
      opacity={1}
      my={0}
    />
  </Stack>
);

export default FooterMobileItems;
